import { transOldExpr } from "@/utils/workFlow"

export default {
  methods: {
    verifyPhonePairs(data, from, topic = "") {
      let msg = ""
      if (from === "add") msg = "请将已有的 key-value 信息填写完整后再添加"
      else if (from === "submit") msg = `请将${topic}已有的 key-value 信息填写完整后再提交`
      for (let item of data) {
        if (!item.code || !item.sheetVar) {
          this.$notify({
            title: "提示",
            message: msg,
            type: "warning"
          })
          return false
        }
      }
      if (from === "submit") {
        let keys = data.map(i => i.code)
        if (keys.length !== new Set(keys).size) {
          this.$notify({
            title: "提示",
            message: "不能存在重复的key，请删掉多余的之后再提交",
            type: "warning"
          })
          return false
        }
      }
      return true
    },
    transOldObjArr(varObjArr) {
      return (varObjArr || []).map(o =>
        Object.assign(o, { value: o.var === false ? o.value : transOldExpr(o.value) })
      )
    },
    transFilters(filters) {
      return filters.map(filter => {
        return filter.map(item => {
          item.key = transOldExpr(item.key)
          item.varItems = item.varItems.map(varItem => {
            if (varItem.var) varItem.value = transOldExpr(varItem.value)
            return varItem
          })
          return item
        })
      })
    }
  }
}
